import type { SxProps } from "@mui/material"

const container: SxProps = {
  width: "100%"
}

const labelContainer = {
  display: "flex",
  flexDirection: "row"
}

const inputStyle = {
  width: "100%",
  height: "44px",
  paddingLeft: "65px"
}
export default { labelContainer, container, inputStyle }
